export default __webpack_public_path__ + "static/lframe-instant-provisioning-3f330c5e4016098c472fae49bc7e4ee6.png";